<template>
  <div>
    <el-dialog custom-class="editor-dialog" :center="center" :close-on-click-modal="closeOnClickModal" :width="width" :visible="dialogVisible" top="8vh"
      :z-index="2000" :before-close="handleClose" @open="onDialogOpen">
      <template #title>
        <span>{{dialogTitle}}</span>
      </template>
      <div class="backgroud-white cs-editor-content" v-loading="loading">
        <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="110px">
          <el-form-item label="序号" prop="Index">
            <el-input placeholder="请输入序号" size="small" :disabled="isFieldsDisabled" v-model="model.Index" class="input-width"
              oninput="value=value.replace(/[^0-9]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(0):null">
            </el-input>
          </el-form-item>
          <el-form-item label="标题" prop="Title" style="margin-bottom: 25px;">
            <el-input type="textarea" resize="none" placeholder="请输入标题" :disabled="isFieldsDisabled" v-model="model.Title" class="input-width" />
          </el-form-item>
          <el-form-item label="注释" prop="Annotation" style="margin-bottom: 20px;">
            <el-input type="textarea" resize="none" placeholder="请输入注释" :disabled="isFieldsDisabled" v-model="model.Annotation" class="input-width" />
          </el-form-item>
          <el-form-item label="问题类型" prop="QuestionType">
            <el-select placeholder="请选择问题类型" :disabled="isFieldsDisabled" v-model="model.QuestionType" @change="onQuestionTypeChange">
              <el-option v-for="(item, index) in GLOBAL.enumQuestionnaireQuestionType.selectListItems" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item v-show="hasFieldValueType" label="值类型" prop="ValueType">
            <el-select placeholder="请选择值类型" :disabled="isFieldsDisabled" v-model="model.ValueType">
              <el-option v-for="(item, index) in GLOBAL.enumQuestionnaireValueType.selectListItems" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否必填">
            <el-select placeholder="请选择是否必填" :disabled="isFieldsDisabled" v-model="model.IsRequired">
              <el-option key="0" label="是" :value="true" />
              <el-option key="1" label="否" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item v-show="hasFieldIsMultiple" label="是否多选">
            <el-select placeholder="请选择是否多选" :disabled="isFieldsDisabled" v-model="model.IsMultiple" @change="onIsMultipleChange">
              <el-option key="1" label="是" :value="true" />
              <el-option key="2" label="否" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item v-show="hasFieldIsCustomized" label="是否自定义" prop="IsCustomized">
            <el-select placeholder="请选择是否自定义" :disabled="isFieldsDisabled" v-model="model.IsCustomized" @change="onIsCustomizedChange">
              <el-option key="1" label="是" :value="true" />
              <el-option key="2" label="否" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item v-show="hasFieldMin" label="最小值" prop="Min">
            <el-input placeholder="请输入最小值" size="small" :disabled="isFieldsDisabled" v-model="model.Min" class="input-width"
              oninput="value=value.replace(/[^0-9]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(0):null">
            </el-input>
          </el-form-item>
          <el-form-item v-show="hasFieldMax" :label="fieldMaxLabel" prop="Max">
            <el-input :placeholder="`请输入${fieldMaxLabel}`" size="small" :disabled="isFieldsDisabled" v-model="model.Max" class="input-width"
              oninput="value=value.replace(/[^0-9]/g,'')" onblur="value=!!value?value.toNumber().toFixedEx(0):null">
            </el-input>
          </el-form-item>
          <el-form-item v-if="isEdit" label="启用状态">
            <el-select placeholder="请选择启用状态" :disabled="isEnableFieldDisabled" v-model="model.Enable">
              <el-option key="0" label="启用" :value="true" />
              <el-option key="1" label="停用" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="hasFieldAnswerOptions" label="回答选项" class="answer-options">
            <div>
              <answerOption v-for="(item, index) in model.AnswerOptions" :key="`answerOption${index}`"
                v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :readonly="isFieldsDisabled" :valueType="model.ValueType" :data="item"
                :customValidator="handleAnswerOptionCustomValidator" @delete="deleteAnswerOption" />

              <div>
                <el-button v-if="!isFieldsDisabled" type="text" class="btn-add" @click="addAnswerOption()">添加</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="questionType-tips">
          <div v-if="model.QuestionType === GLOBAL.enumQuestionnaireQuestionType.Rate">
            <span v-if="model.IsCustomized">注：是否自定义为是时，需配置回答选项</span>
            <span v-else>注：是否自定义为否时，将自动生成(最小值-最大值)的评分项</span>
          </div>
          <div v-else-if="model.IsMultiple">
            <span>注：最大多选数设置为0时，允许多选所有项</span>
          </div>
        </div>
        <div class="dialog-footer popup-footer">
          <el-row v-if="!isEnableFieldDisabled">
            <el-col>
              <el-button :disabled="readonly || loading || isSaving" :loading="isSaving" type="primary" @click="saveChanges">确认</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { saveQuestionnaireQuestion } from "@/service/questionnaire.service";

const default_dataModel = {
  Id: 0,
  Enable: true,
  QuestionnaireId: 0,
  Index: null,
  Title: null,
  Annotation: null,
  QuestionType: null,
  ValueType: 0,
  IsRequired: false,
  IsMultiple: null,
  Min: null,
  Max: null,
  IsCustomized: null,
  AnswerOptions: [],
};

const default_answerOptionModel = {
  Id: 0,
  Enable: true,
  QuestionnaireQuestionId: 0,
  Index: null,
  Label: null,
  Value: null,
};

const mixin_generalMethods = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      if (isValid && this.hasFieldAnswerOptions) {
        if (this.model.AnswerOptions.length === 0) {
          this.$message({
            message: "回答选项不能为空",
            type: "error",
          });
          return false;
        }

        for (let i = 0; i < this.model.AnswerOptions.length; i++) {
          let aoRef = this.$vueRefStore.getChildrenRef(`answerOption${i}`);
          if (!!aoRef) {
            isValid &= aoRef.validate();
          }
        }
      }

      return !!isValid;
    },
  },
};

export default {
  name: "questionnaireQuestionEditor",
  mixins: [mixin_generalMethods],
  components: {
    answerOption: () => import("./answerOption"),
  },
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "60%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(default_dataModel);
      },
    },
    questionnaireId: {
      type: Number,
      default: 0,
    },
    haveStudentRecords: {
      type: Boolean,
      default: false,
    },
    maxIndex: {
      type: Number,
      default: null,
    },
    customValidator: {
      type: Function,
      default: null,
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    const indexValidator = (rule, value, callback) => {
      let message = "";

      if (!!this.customValidator) {
        let fixedValue = `${value}`.toNumber();
        let fieldName = "Index";
        let result = this.customValidator(fixedValue, fieldName, this.model);
        if (!!result[fieldName] && !result[fieldName].success) {
          message = result[fieldName].message;
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    const minValidator = (rule, value, callback) => {
      let message = "";

      if (this.hasFieldMin) {
        if (!value && value !== 0) {
          message = "请输入最小值";
        }
      }

      if (!message && this.hasFieldMin && this.hasFieldMax) {
        let numValue = `${value}`.toNumber();
        if (numValue > this.model.Max) {
          message = `最小值不能大于${this.fieldMaxLabel}`;
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    const maxValidator = (rule, value, callback) => {
      let message = "";

      if (this.hasFieldMax) {
        if (!value && value !== 0) {
          message = `请输入${this.fieldMaxLabel}`;
        }
      }

      if (!message && this.hasFieldMin && this.hasFieldMax) {
        let numValue = `${value}`.toNumber();
        if (numValue < this.model.Min) {
          message = `${this.fieldMaxLabel}不能小于最小值`;
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      isSaving: false,
      dialogVisible: false,
      rules: {
        Index: [
          {
            required: true,
            message: "请输入序号",
            trigger: "blur",
          },
          {
            validator: indexValidator,
            trigger: "blur",
          },
        ],
        Title: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        QuestionType: [
          {
            required: true,
            message: "请选择问题类型",
            trigger: "blur",
          },
        ],
        ValueType: [
          {
            required: true,
            message: "请选择值类型",
            trigger: "blur",
          },
        ],
        Min: [
          {
            validator: minValidator,
            trigger: "blur",
          },
        ],
        Max: [
          {
            validator: maxValidator,
            trigger: "blur",
          },
        ],
      },
      model: Object.clone(default_dataModel),
    };
  },
  created() {
    this.reloadVisible();
  },
  computed: {
    isEdit() {
      return !!this.data && !!this.data.Id;
    },
    isFieldsDisabled() {
      if (this.readonly) return true;

      return this.haveStudentRecords;
    },
    isEnableFieldDisabled() {
      return this.readonly;
    },
    dialogTitle() {
      let baseValue = "问卷问题";
      if (this.isFieldsDisabled) return `查看${baseValue}`;
      if (this.isEdit) return `编辑${baseValue}`;
      return `添加${baseValue}`;
    },
    hasFieldValueType() {
      switch (this.model.QuestionType) {
        case this.GLOBAL.enumQuestionnaireQuestionType.Choice: {
          return true;
        }
      }

      return false;
    },
    hasFieldIsMultiple() {
      switch (this.model.QuestionType) {
        case this.GLOBAL.enumQuestionnaireQuestionType.Choice: {
          return true;
        }
      }

      return false;
    },
    hasFieldIsCustomized() {
      switch (this.model.QuestionType) {
        case this.GLOBAL.enumQuestionnaireQuestionType.Rate: {
          return true;
        }
      }

      return false;
    },
    hasFieldMin() {
      switch (this.model.QuestionType) {
        case this.GLOBAL.enumQuestionnaireQuestionType.Rate: {
          return !this.model.IsCustomized;
        }
      }

      return false;
    },
    hasFieldMax() {
      switch (this.model.QuestionType) {
        case this.GLOBAL.enumQuestionnaireQuestionType.Choice: {
          if (this.model.IsMultiple) return true;

          return false;
        }
        case this.GLOBAL.enumQuestionnaireQuestionType.Rate: {
          return !this.model.IsCustomized;
        }
      }

      return false;
    },
    hasFieldAnswerOptions() {
      switch (this.model.QuestionType) {
        case this.GLOBAL.enumQuestionnaireQuestionType.Choice: {
          return true;
        }
        case this.GLOBAL.enumQuestionnaireQuestionType.Rate: {
          return this.model.IsCustomized;
        }
      }

      return false;
    },
    fieldMaxLabel() {
      if (
        this.model.QuestionType ===
        this.GLOBAL.enumQuestionnaireQuestionType.Choice
      )
        return "最大多选数";

      return "最大值";
    },
  },
  methods: {
    // 和服务端进行数据交互相关方法
    async saveQuestionnaireQuestionToServer() {
      this.isSaving = true;

      let saveData = Object.clone(this.model);
      saveData.Index = `${saveData.Index}`.toNumber();
      saveData.Min =
        !!saveData.Min || saveData.Min === 0
          ? `${saveData.Min}`.toNumber()
          : null;
      saveData.Max =
        !!saveData.Max || saveData.Max === 0
          ? `${saveData.Max}`.toNumber()
          : null;
      if (
        saveData.QuestionType ===
          this.GLOBAL.enumQuestionnaireQuestionType.Rate &&
        !saveData.IsCustomized
      ) {
        saveData.AnswerOptions = this.isEdit ? this.data.AnswerOptions : [];
      }
      if (!this.isEdit) {
        saveData.QuestionnaireId = this.questionnaireId;
      }

      try {
        let result = await saveQuestionnaireQuestion(saveData);
        if (!!result && result.success) {
          this.model.Id = result.data;
          this.$message({
            message: "保存问卷问题成功",
            type: "success",
          });
          this.$emit("change", this.model);
          return true;
        } else {
          this.$message({
            message: result.message || "保存问卷问题失败",
            type: "error",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }

      return false;
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible === newValue) return;

      this.dialogVisible = newValue;
      if (this.dialogVisible) this.reloadDataFromProps();
    },
    clearValidate() {
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        try {
          refForm.clearValidate();
        } catch (error) {}
      }
    },
    resetData() {
      this.model = Object.clone(default_dataModel);

      this.$nextTick(() => {
        this.clearValidate();
      });
    },
    async reloadDataFromProps() {
      if (!this.dialogVisible) return;

      this.model = Object.clone(this.data || default_dataModel);
      this.model.Min =
        !!this.model.Min || this.model.Min === 0 ? `${this.model.Min}` : null;
      this.model.Max =
        !!this.model.Max || this.model.Max === 0 ? `${this.model.Max}` : null;

      if (!this.isEdit && (!!this.maxIndex || this.maxIndex === 0)) {
        this.model.Index = this.maxIndex + 1;
      }
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    async closeDialog() {
      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadDataFromProps();
    },
    handleClose(done) {
      this.$nextTick(() => {
        this.resetData();

        this.closeDialog();
      });
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      this.$nextTick(async () => {
        let result = await this.saveQuestionnaireQuestionToServer();
        if (result) this.closeDialog();
      });
    },
    addAnswerOption() {
      let newAnswerOption = Object.clone(default_answerOptionModel);
      let allIndexes = this.model.AnswerOptions.map((item) => item.Index);
      let maxIndex = allIndexes.length > 0 ? Math.max(...allIndexes) : 0;
      newAnswerOption.Index = maxIndex + 1;
      newAnswerOption.QuestionnaireQuestionId = this.model.Id;
      this.model.AnswerOptions.push(newAnswerOption);
    },
    deleteAnswerOption(item) {
      this.model.AnswerOptions.remove(item);
    },
    onQuestionTypeChange(newVal) {
      switch (newVal) {
        case this.GLOBAL.enumQuestionnaireQuestionType.Choice: {
          this.model.ValueType = this.GLOBAL.enumQuestionnaireValueType.String;
          this.model.IsMultiple = false;
          this.model.Min = null;
          this.model.Max = null;
          this.model.IsCustomized = null;
          break;
        }
        case this.GLOBAL.enumQuestionnaireQuestionType.Rate: {
          this.model.ValueType = this.GLOBAL.enumQuestionnaireValueType.Int32;
          this.model.IsMultiple = null;
          this.model.Min = "0";
          this.model.Max = "5";
          this.model.IsCustomized = false;
          break;
        }
        default: {
          this.model.ValueType = this.GLOBAL.enumQuestionnaireValueType.String;
          this.model.IsMultiple = null;
          this.model.Min = null;
          this.model.Max = null;
          this.model.IsCustomized = null;
          break;
        }
      }

      this.$nextTick(() => {
        this.clearValidate([
          "ValueType",
          "IsMultiple",
          "Min",
          "Max",
          "IsCustomized",
        ]);
      });
    },
    onIsMultipleChange(newVal) {
      this.model.Max = newVal ? 0 : null;

      this.$nextTick(() => {
        this.clearValidate(["Max"]);
      });
    },
    onIsCustomizedChange(newVal) {
      this.model.Min = !newVal ? "0" : null;
      this.model.Max = !newVal ? "5" : null;

      this.$nextTick(() => {
        this.clearValidate(["Min", "Max"]);
      });
    },
    handleAnswerOptionCustomValidator(value, fieldName, model) {
      let result = {};

      let otherItems = this.model.AnswerOptions.filter(
        (item) => item !== model
      );
      switch (fieldName) {
        case "Index": {
          let indexUsed = otherItems.some(
            (item) => `${item.Index}`.toNumber() === `${value}`.toNumber()
          );
          result[fieldName] = {
            success: !indexUsed,
            message: indexUsed ? "序号已被使用" : null,
          };
          break;
        }
        case "Value": {
          let valueUsed = otherItems.some(
            (item) => `${item.Value}` === `${value}`
          );
          result[fieldName] = {
            success: !valueUsed,
            message: valueUsed ? "值已被使用" : null,
          };
          break;
        }
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .editor-dialog {
    min-width: 400px;

    .el-dialog__header {
      font-size: 1.75em;
      font-weight: bold;
    }
  }
}

.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;
  max-height: 420px;

  .el-form-item {
    margin-bottom: 12px;

    .input-width {
      width: 100%;
    }

    &.answer-options {
      .btn-add {
        margin-left: 5px;
      }
    }
  }
}

.questionType-tips {
  color: rgba(#606266, 0.65);
}
</style>


// WEBPACK FOOTER //
// src/components/questionnaire/questionnaireQuestionEditor.vue